export default __webpack_public_path__ + "static/media/imghomepagebanner 5.52e45bc4.webp";